// Connections getters
export default {
  get_shops: (state) => state.shops,
  get_shop_by_id: (state) => (id) => state.shops.items.filter((shop) => shop.id === id)[0],
  get_shipping_methods: (state) => state.shippingMethods,
  get_shipping_method_by_id: (state) => (id) => state.shippingMethods.items.filter((shippingMethod) => shippingMethod.id === id)[0],
};
